import styled from "styled-components";

export const Container = styled.div`
    
    .FirstTab {
        display: flex;
        flex: 1;
        align-items: center;
    }
`;